@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Oregon</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <!-- Trucks or Passengers Selection -->
      @if (controls?.length >= 1) {
        <p>This policy provides coverage for (select one option):</p>
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[0].formControlName)?.touched &&
              reactiveForm.get(controls[0].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      <!-- UM Radio Group level one -->
      @if (controls?.length >= 2) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[1].formControlName)?.touched &&
              reactiveForm.get(controls[1].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
            @if (reactiveForm.get(controls[1].formControlName)?.touched) {
              @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
                <span
                  class="axis-error-block"
                  role="alert"
                  >Please select an option.</span
                >
              }
            }
          </axis-radio-button-wrapper>
        </div>
      }
      <!-- Read Only Section of Outstanding -->
      @if (
        baseRules?.Reject_LevelTwo_UM_Radio?.includes("Yes")) {
        <div class="axis-form-group">
          <label
            class="axis-control-label"
            id="reject_leveltwo_um_radio-pdffield-oregon"
          >
            {{ textValues?.Rejects_UMBI }}
          </label>
        </div>
      }
      <!-- UM Radio Group level two -->
      @if (controls?.length >= 3) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[2].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[2].formControlName)?.touched &&
              reactiveForm.get(controls[2].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[2].formControlName }}">
            @for (control of controls[2].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[2].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[2].formControlName)?.touched) {
            @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }

      <!-- UM Dropdowns -->
      <div class="axis-grid">
        @for (control of controls | slice: 4 : 8; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                >
                  {{ control.label }}
                </label>

                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                  (onSelect)="onSelect(baseRules['selectionId'], control.formControlName); handleDropdownSelection(control, $event);"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select an option.</span
                    >
                  }
                }

              </div>
            </div>
          }
        }
      </div>
      <div class="axis-grid">
        @if ((baseRules?.["SplitMinLimits_DropDown"] || "").includes("readonly")) {
          <div
            class="axis-col-sm-6 axis-col-lg-4"
          >
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[6].label }}</label>
              <div id="splitminlimits_25k_50k-pdffield-oregon">{{ controls[6].data[0].name }}</div>
            </div>
          </div>
        }
        @if ((baseRules?.["CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
          <div
            class="axis-col-sm-6 axis-col-lg-4"
          >
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[7].label }}</label>
              <div id="combinedsingleminlimit_50k-pdffield-oregon">{{ controls[7].data[0].name }}</div>
            </div>
          </div>
        }
        @if ((baseRules?.["LiabilityLimit_DropDown"] || "").includes("readonly")) {
          <div
            class="axis-col-sm-6 axis-col-lg-4"
          >
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[10].label }}</label>
              <div id="liabilitylimit_Limit_equal_to_the_limit_of_my_Bodily_Injury_Liability_Coverage-pdffield-oregon">{{ controls[10].data[0].name }}</div>
            </div>
          </div>
        }
      </div>
      <!-- UIM Radio group level one -->
      @if (controls?.length >= 4) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[3].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[3].formControlName)?.touched &&
              reactiveForm.get(controls[3].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[3].formControlName }}">
            @for (control of controls[3].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[3].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[3].formControlName)?.touched) {
            @if (reactiveForm.get(controls[3].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }

      <!-- UIM Dropdowns -->
      <div class="axis-grid">
        @for (control of controls | slice: 8; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                >
                  {{ control.label }}
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select an option.</span
                    >
                  }
                }
              </div>
            </div>
          }
        }
      </div>
        @if (baseRules?.Reject_LevelTwo_UIM_Radio?.includes("Yes")) {
    <div class="axis-form-group">
      <label
        class="axis-control-label"
        id="reject_leveltwo_uim_radio-pdffield-oregon"
      >
        {{ textValues?.Rejects_UMPD }}
      </label>
    </div>
  }
    <!-- UMPD Min Limits Readonly -->
    @if ((baseRules?.["UMPDMinLimits_DropDown"] || "").includes("readonly")) {
       <div class="axis-grid">
          <div class="axis-col-sm-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[9].label }}</label>
              <div id="umpdminlimits_20k-pdffield-oregon">{{ controls[9].data[0].name }}</div>
            </div>
          </div>
       </div>
     }
    </form>
  }


  <p>{{ textValues?.description }}</p>
}

<!-- Review Section -->
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Oregon</h2>
  <!-- DROPDOWN VALUES -->
  <div class="axis-grid">
    @for (control of controls | slice: 5; track $index) {
      @if (baseRules[control.baseRuleKey]) {
        <div class="axis-col-sm-6 axis-col-lg-4">
          <div class="axis-form-group">
            <label class="axis-control-label">{{ control.label }}</label>
            <div>{{ control.data[0].name }}</div>
          </div>
        </div>
      }
    }
  </div>
  @if (baseRules?.Reject_LevelTwo_UIM_Radio) {
    <div class="axis-form-group">
      <label id="reject_leveltwo_uim_radio-pdffield-oregon" class="axis-control-label">
        {{ textValues?.Rejects_UMPD }}
      </label>
    </div>
  }
}
